   <div class="logo-container">
        <img class="logo" src="./assets/AdminAI-blanco.png" alt="AdminAI">
    </div>
<section class="sect-hero" appViewportEnterDirective (viewPortEntered)="activeRoute.setActiveRoute('home')">

    <div class="text-and-video-cont">
        <div class="text-cont">
            
            <h1>
                La 
                <span >
                    IA    
                </span>
                 de las <br> <span>
                    Administraciones
                 </span>  y Consorcios
            </h1>
            <p class="subtitle">
                AdminAI es una plataforma desarrollada específicamente para administradores y consorcistas, con IA entrenada para aliviar la carga de trabajo. 
            </p>
        <div class="btn-cont">
            <a  routerLink="/auth/register" class="button-primary-3">
                Suscribite ya
            </a>    
            <button (click)="fullVideo = !fullVideo" class="btn btn-arrow">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M8.91003 19.9201L15.43 13.4001C16.2 12.6301 16.2 11.3701 15.43 10.6001L8.91003 4.08008" stroke="#292D32" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                <span>

                    Ver demo
                </span>
            </button>
        </div>
        <img class="separator" src="./assets/separator.png" alt="">
            <div class="icons-cont">
                <div class="icon-and-text">
                    <img src="./assets/hero-sect-icon1.svg" alt="icono de robot">
                    <p><span>
                        Filtra y organiza 
                    </span><br /> 
                         tu carga laboral.</p>
                </div>
                <div class="icon-and-text">
                    <img src="./assets/hero-sect-icon2.svg" alt="icono de IA">
                    <p><span>
                        Sumá IA y potenciá 
                    </span> <br />
                        tu administración.</p>
                </div>
            </div>
        </div>
        <div class="video-cont">
            
                <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/dQw4w9WgXcQ?si=cGjL-MzcGgqilo7b" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
            <div class="video" (click)="fullVideo = false" [ngClass]="{cine:fullVideo}">
                <div class="close-button">
                    <button (click)="fullVideo = false"> Cerrar demo</button>
                </div>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/CsDjHNzS6EA?si=JFmXeyBc76nd3qyn" title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            
               <!--  <button class=" btn btn-play">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16.6582 9.28638C18.098 10.1862 18.8178 10.6361 19.0647 11.2122C19.2803 11.7152 19.2803 12.2847 19.0647 12.7878C18.8178 13.3638 18.098 13.8137 16.6582 14.7136L9.896 18.94C8.29805 19.9387 7.49907 20.4381 6.83973 20.385C6.26501 20.3388 5.73818 20.0469 5.3944 19.584C5 19.053 5 18.1108 5 16.2264V7.77357C5 5.88919 5 4.94701 5.3944 4.41598C5.73818 3.9531 6.26501 3.66111 6.83973 3.6149C7.49907 3.5619 8.29805 4.06126 9.896 5.05998L16.6582 9.28638Z" stroke="#000000" stroke-width="2" stroke-linejoin="round"></path> </g></svg>
                </button> -->
        </div>
    </div>
    <div class="rectangle">
        <p>Reduce entre un 50% y un 70% las intervenciones del Administrador, ahorrando tiempo y dinero, y brindando un servicio de calidad a sus clientes.</p>
    </div>
</section>